
import ProjectCard from './ProjectCard.vue'

export default {
  components: { ProjectCard },
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
}
